import type { IconData } from '@stacksjs/iconify-core'

export const controlButtonsPause: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6.88.16H.16v15.68h6.72zm8.96 0H9.12v15.68h6.72z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default controlButtonsPause
